import { EmptyValue } from "@/components/ui/empty-value";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { getVehicleBooleanLabel } from "@/modules/fab/vehicle-valuation/_helpers/vehicle-valuation-metadata";
import { CircleHelpIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

interface VehicleValuationReimportDisplayProps {
  reimport?: boolean | null;
}

export function VehicleValuationReimportDisplay({ reimport }: VehicleValuationReimportDisplayProps) {
  const { t } = useTranslation(["common", "fab"]);
  const label = getVehicleBooleanLabel(reimport, t);
  const tooltipText = t("fab:VehicleValuationDatReimportHint");

  return (
    <TooltipProvider>
      <span className="inline-flex flex-wrap items-center gap-1.5">
        <span>{label ? label : <EmptyValue />}</span>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              className="inline-flex h-4 w-4 shrink-0 cursor-help items-center justify-center rounded-sm text-sky-600 transition-colors hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300"
              aria-label={tooltipText}
            >
              <CircleHelpIcon className="h-3.5 w-3.5" aria-hidden="true" />
            </button>
          </TooltipTrigger>
          <TooltipContent className="max-w-xs space-y-1">
            <p className="font-medium">{t("fab:VehicleValuationProviderDAT")}</p>
            <p>{tooltipText}</p>
          </TooltipContent>
        </Tooltip>
      </span>
    </TooltipProvider>
  );
}
